__turbopack_context__.v({
  "className": "fM4USq_className",
  "variable": "fM4USq_variable",
});
